import React, { Component } from "react";
import EditIcon from "@material-ui/icons/Edit";
import { Form } from "semantic-ui-react";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import AvatarGroup from "@material-ui/lab/AvatarGroup";
import { GetContactData } from "../../actions-index";
export default class Contacts extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.state = {
      query: "",
      bgcolor: "#bdbdbd",
      alphabet: "",
      data: [],
      filteredData: [],
      responseData: {
        data: "",
        pk: "",
        EmailAddress: "",
        EmailAddress2: "",
        FirstName: "",
        LastName: "",
        isOrganization: false,
        Organization: "",
      },
      isLoading: true,
    };
    this.user = sessionStorage.getItem("UserName");
  }
  async componentDidMount() {
    localStorage.setItem("contactdata", null);
    await GetContactData().then((responseData) =>
      this.setState({
        data: responseData,
        isLoading: false,
        responseData: responseData,
      })
    );
  }
  handleInputChange = (event) => {
    this.setState(
      {
        query: event.target.value,
      },
      () => {
        this.filterArray();
      }
    );
  };
  handleAlphabetChange = (event) => {
    this.setState(
      {
        query: event.target.value,
      },
      () => {
        this.filterArray();
      }
    );
  };
  onAlphabetClick = (e) => {
    this.setState({ alphabet: this.state.alphabet === e ? "" : e }, () => {
      this.filterArray();
    });
  };
  filterArray = () => {
    const { query, alphabet, data } = this.state;
    let searchString = "";
    let searchStringArr = query.split(" ");
    searchStringArr.forEach((element) => {
      searchString = searchString + "(?=.*" + element + ")";
    });
    const regexp = new RegExp(searchString, "i");
    let filterResponseData = data;
    if (query.length > 2 || alphabet) {
      filterResponseData = filterResponseData.filter((element) => {
        return element.data.toLowerCase().search(regexp) > -1;
      });
      if (alphabet) {
        filterResponseData = filterResponseData.filter((element) => {
          return element.LastName
            ? element.LastName.charAt(0).toLowerCase() ===
                alphabet.toLowerCase()
            : element.Organization.charAt(0).toLowerCase() ===
                alphabet.toLowerCase();
        });
      }
      this.setState({
        responseData: filterResponseData,
      });
    } else {
      this.setState({ responseData: data });
    }
  };
  prepareAlphabets = () => {
    let result = [];
    for (let i = 65; i < 91; i++) {
      result.push(
        // <button type="button" key={i} onClick={this.onAlphabetClick} value={String.fromCharCode(i)} >
        <Avatar
          onClick={this.onAlphabetClick.bind(this, String.fromCharCode(i))}
          key={i}
          value={String.fromCharCode(i)}
          // style={back}
          style={{
            backgroundColor:
              String.fromCharCode(i) === this.state.alphabet
                ? "#bb0000"
                : "#bdbdbd",
          }}
        >
          {String.fromCharCode(i)}
        </Avatar>
      );
    }
    return result;
  };

  render() {
    const ListContactComponent = React.lazy(() =>
      import("./components/ListContactComponent")
    );
    const scarletWhite = {
      backgroundColor: "#BB0000",
      color: "#fff",
    };
    const { responseData } = this.state;
    if (this.state.isLoading) {
      return (
        <CircularProgress
          className="mt-2"
          width={60}
          height={60}
          color="primary"
        />
      );
    } else {
      return (
        <div className="edit-form">
          <Typography variant="h2">
            <EditIcon />
            Search Contacts
          </Typography>
          <Link to={"/addcontact"}>
            <button style={scarletWhite}>Add New Contact</button>
          </Link>
          <AvatarGroup max={30}>{this.prepareAlphabets()}</AvatarGroup>
          {
            <Form>
              <Form.Input
                placeholder="Search for Contact Name or Email..."
                value={this.state.query}
                onChange={this.handleInputChange}
              />
            </Form>
          }
          {responseData.length > 0 ? (
            <ListContactComponent data={responseData} />
          ) : (
            <div></div>
          )}
        </div>
      );
    }
  }
}
